import { render, staticRenderFns } from "./file-upload-dialog.vue?vue&type=template&id=3b4345a9&"
import script from "./file-upload-dialog.vue?vue&type=script&lang=js&"
export * from "./file-upload-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports